import BootstrapData from './BootstrapData';

class Domain {
  static getDomain() {
    const { domain } = (BootstrapData.load() || { domain: 'prod' }); // If the data is missing default to prod.
    return domain;
  }

  static isProd() {
    const domain = this.getDomain();
    return domain === 'master' || domain === 'prod';
  }
}

export default Domain;
